// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2pBgv","subheader":"ReorderModal_subheader__b-Y1k","listWrap":"ReorderModal_listWrap__2t53I"};